import React, { useState, useEffect,useContext } from 'react';
import {
  Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip,
  Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, Box,
  Menu, useMediaQuery, InputAdornment, IconButton, TablePagination, Snackbar,Alert, Popover,
  FormControlLabel,Checkbox, Skeleton
} from '@mui/material';
import { Card, CardContent, CardActions, Grid } from '@mui/material';
import api from '../api';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import LockResetIcon from '@mui/icons-material/LockReset';
import { useTheme } from '@mui/material/styles';
import MuiAlert from '@mui/material/Alert';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditButton from '../customcomponents/CustomEditButton';
import DeleteButton from '../customcomponents/CustomDeleteButton';
import SearchInput from '../customcomponents/CustomSearchInput';
import PillComponent from '../customcomponents/CustomPillComponent';
import { SettingsContext } from '../App';

import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import { Landmark } from 'lucide-react';

const initialUsers = [
  { id: 1, name: 'John Admin', email: 'admin@tracksapp.com', mobile: '9876543210', role: 'Admin', status: 'Active' },
  { id: 2, name: 'Priya Staff', email: 'priya.staff@tracksapp.com', mobile: '9876543211', role: 'Staff', status: 'Active' },
  { id: 3, name: 'Dr. Kumar', email: 'kumar.doctor@tracksapp.com', mobile: '9876543212', role: 'Doctor', status: 'Active' },
];

const statuses = ['Active', 'Inactive'];

function UserMasterPage() {
  const [viewUserDialog, setViewUserDialog] = useState(false);
  const [viewedUser, setViewedUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', mobile: '', role: '', status: statuses[0], username: '', password: '', confirmPassword: '', masterRef: '', addressOne:'', addressTwo:'',Landmark:'' });
  const [roles, setRoles] = useState([]);
  const [masterUsers, setMasterUsers] = useState([]);
  const [masterPro, setMasterPro] = useState([]);
  const [editUserId, setEditUserId] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [changePasswordDialog, setChangePasswordDialog] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [passwordForm, setPasswordForm] = useState({ newPassword: '', confirmPassword: '' });
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [phoneError, setPhoneError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [masterUserError, setMasterUserError] = useState('');
  const [masterProError, setMasterProError] = useState('');
  const theme = useTheme();
  const isSmallScreen = useMediaQuery('(max-width:800px)');
  const [anchorEl, setAnchorEl] = useState(null);
  const openPopover = Boolean(anchorEl);
  const {userRole ,settings}=useContext(SettingsContext);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [menuUserId, setMenuUserId] = useState(null);

  const [isActive, setIsActive] = useState(false);
  const [isLocationShared, setIsLocationShared] = useState(false);
  const [notifyAlertType, setNotifyAlertType] = useState({type:'',isActive:false});

  const canAccess = (keyName) => {
    const item = settings?.find(s => s.keyName === keyName);
    return item?.roles?.some(r => r.roleName === userRole);
  };

  const canHidePro = canAccess("hide_pro");

  const handleMenuOpen = (event, userId) => {
    setMenuAnchor(event.currentTarget);
    setMenuUserId(userId);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setMenuUserId(null);
  };
  const handleSearchClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbar({ ...snackbar, open: false });
  };

  const fetchUsers = async () => {
    setLoading(true)
    try {
      const res = await api.get('/users');
      if (res.data) {
        if (res.data.success && Array.isArray(res.data.data)) {
          let usersData = res.data.data.map(user => ({
            id: user.id,
            name: user.name,
            email: user.email,
            mobile: user.mobileNumber,
            role: user.roleId,
            roleName: user.roleName || '',
            status: 'Active',
            username: user.username ? user.username : '',
            locationShared: user.locationShared || false,
            isActive: user.isActive || false,
          }));
          if(userRole.toLowerCase() ==='admin'){
            usersData=usersData.filter(r=>r?.roleName.toLowerCase()!='superadmin');
          }
          setUsers(usersData);
          setLoading(false);
        } else {
          setUsers([]);
        }
      } else {
        setUsers([]);
      }
    } catch (err) {
      showSnackbar('Failed to load users. Please check console for details.', 'error');
      setUsers([]);
    }
  };

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const res = await api.get('/roles');
        let rolesArr = [];
        if (Array.isArray(res.data.data)) {
          rolesArr = res.data.data.map(r => ({
            _id: r._id,
            TA_Role_Name: r.TA_Role_Name || r.name || r.role || ''
          }));
        }
        if(userRole.toLowerCase() ==='admin'){
          rolesArr=rolesArr.filter(role=>role?.TA_Role_Name.toLowerCase()!='superadmin');
        }
        setRoles(rolesArr);
        if (rolesArr.length > 0) {
          setForm(f => ({ ...f, role: rolesArr[0]._id }));
        }
      } catch {
        setRoles([]);
      }
    };
    fetchRoles();
    fetchMasterUsers();
    fetchMasterPro();
    fetchUsers();
  }, []);

  const handleOpen = () => {
    setEditUserId(null);
    // reset checkbox states for creating a new user
    setIsActive(false);
    setIsLocationShared(false);
    setForm({ name: '', email: '', mobile: '', role: roles[0]?._id || '', status: statuses[0], username: '', password: '', confirmPassword: '', masterRef: '', proRef: '' });
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    // reset form and checkbox states
    setForm({ name: '', email: '', mobile: '', role: roles[0]?._id || '', status: statuses[0], username: '', password: '', confirmPassword: '', masterRef: '', proRef: '' });
    setIsActive(false);
    setIsLocationShared(false);
    setPhoneError('');
    setAnchorEl(null);
    // setSearch('');
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'mobile') {
      if (!/^\d{0,10}$/.test(value)) return;
      setPhoneError(value.length === 10 || value.length === 0 ? '' : 'Phone number must be 10 digits');
    }
    if (name === 'password' || name === 'confirmPassword') {
      const newForm = { ...form, [name]: value };
      if (newForm.password && newForm.confirmPassword && newForm.password !== newForm.confirmPassword) {
        setPasswordError('Passwords do not match');
      } else {
        setPasswordError('');
      }
      setForm(newForm);
      return;
    }
    setForm({ ...form, [name]: value });
  };
  const fetchMasterUsers = async () => {
    try {
      const res = await api.get('/users');
      if (res.data && res.data.success && Array.isArray(res.data.data)) {
        let masterUsers=(res.data.data.map(user => ({
          _id: user.id,
          name: user.name || 'Unnamed User',
          email: user.email,
          mobileNumber: user.mobileNumber,
          roleName: user.roleName,
          masterUser: user.masterUser || null,
          masterPro: user.masterPro || null,
          locationShared: user.locationShared || false,
          isActive: user.isActive || false
        })));
        if (userRole?.toLowerCase() === 'admin') {
          masterUsers = masterUsers.filter(
            u => u.roleName?.toLowerCase() !== 'superadmin'
          );
        }
        setMasterUsers(masterUsers);
      }
      else {
        setMasterUsers([]);
      }
    } catch (err) {
      setMasterUsers([]);
    }
  };

  const fetchMasterPro = async () => {
    try {
      const res = await api.get('/pro-masters');
      if (res.data && res.data.success && Array.isArray(res.data.data)) {
        setMasterPro(res.data.data.map(pro => ({
          _id: pro._id,
          name: pro.name || 'Unnamed PRO',
        })));
      } else {
        setMasterPro([]);
      }
    } catch (err) {
      setMasterPro([]);
    }
  };

  const handleSubmit = async () => {
    if (editUserId !== null) {
      try {
        setLoading(true);
        const payload = {
          TA_User_Name: form.name,
          TA_User_Email: form.email,
          TA_User_Mobile_Number: form.mobile,
          TA_User_Role_Ref: form.role,
          TA_Master_User_Ref: form.masterRef,
          TA_PRO_Ref: form.proRef,
          TA_Username: form.username,
          TA_Status: form.status === 'Active' ? 1 : 0,
          TA_IsLocationShared: isLocationShared,
          TA_IsActive: isActive,
          TA_NotifyAlertType: notifyAlertType.isActive ? notifyAlertType.type : 'Default',
          TA_Address_Line_One: form.addressOne,
          TA_Address_Line_Two: form.addressTwo,
          TA_LandMark: form.Landmark,
        };
        if (form.password) {
          payload.password = form.password;
          payload.confirmPassword = form.confirmPassword;
        }
        await api.put(`/users/${editUserId}`, payload);
        setUsers(users.map(u =>
          u.id === editUserId
            ? { ...u, name: form.name, email: form.email, mobile: form.mobile, role: form.role, status: form.status, username: form.username, masterRef: form.masterRef, proRef: form.proRef }
            : u
        ));
        showSnackbar('User updated successfully', 'success');
        handleClose();
        await fetchUsers();
      } catch (err) {
        alert('Failed to update user: ' + (err.response?.data?.message || err.message));
      } finally {
        setLoading(false);
      }
      return;
    }
    setLoading(true);
    if (form.mobile.length !== 10) {
      setPhoneError('Phone number must be 10 digits');
      setLoading(false);
      return;
    }
    if (form.password !== form.confirmPassword) {
      setPasswordError('Passwords do not match');
      setLoading(false);
      return;
    }
    if (!form.masterRef) {
      setMasterUserError('Please select a Master User');
    }
    setMasterUserError('');
    // if (!form.proRef) {
    //   setMasterProError('Please select a Master PRO');
    // }
    setMasterProError('');
    try {
      const payload = {
        TA_User_Name: form.name,
        TA_User_Mobile_Number: form.mobile,
        TA_User_Email: form.email,
        TA_Username: form.username,
        TA_User_Password: form.password,
        TA_Confirm_Password: form.confirmPassword,
        TA_User_Role_Ref: form.role,
        TA_Master_User_Ref: form.masterRef,
        TA_Status: form.status === 'Active' ? 1 : 0,
        TA_PRO_Ref: form.proRef || null,
        TA_IsLocationShared: isLocationShared,
        TA_IsActive: isActive,
        TA_NotifyAlertType: notifyAlertType.isActive ? notifyAlertType.type : 'Default',
        TA_Address_Line_One: form.addressOne,
        TA_Address_Line_Two: form.addressTwo,
        TA_LandMark: form.Landmark,
      };
      await api.post('/users', payload);
      showSnackbar('User added successfully!', 'success');
      setUsers([
        ...users,
        { id: users.length + 1, ...form },
      ]);
      handleClose();
      window.location.reload();
    } catch (err) {
      alert('Failed to add user: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (user) => {
    try {
      const res = await api.get(`/users/${user.id || user._id}`);
      if (res.data && res.data.success) {
        const userData = res.data.data;
        setForm({
          name: userData.TA_User_Name || userData.name || '',
          email: userData.TA_User_Email || userData.email || '',
          mobile: userData.TA_User_Mobile_Number || userData.mobileNumber || '',
          role: userData.role?.id || userData.TA_User_Role_Ref?._id || '',
          status: userData.TA_Status === 1 ? 'Active' : 'Inactive',
          username: userData.TA_Username || userData.username || '',
          password: '',
          confirmPassword: '',
          masterRef: userData.masterUser?.id || '',
          proRef: userData.masterPro?.id || '',
          locationShared: userData.TA_IsLocationShared || userData.locationShared || false,
          isActive: userData.TA_IsActive || userData.isActive || false
        });
        // ensure the checkbox controls reflect DB values
        setIsLocationShared(Boolean(userData.TA_IsLocationShared || userData.locationShared));
        setIsActive(Boolean(userData.TA_IsActive || userData.isActive));
        setEditUserId(userData._id || userData.id);
        setOpen(true);
      }
    } catch (err) {
      alert('Failed to load user details: ' + (err.response?.data?.message || err.message));
    }
  };
  const handleDelete = (id) => {
    setUserToDelete(id);
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await api.delete(`/users/${userToDelete}`);
      setUsers(users.filter(u => u.id !== userToDelete));
      showSnackbar('User deleted successfully', 'success');
    } catch (err) {
      alert('Failed to delete user: ' + (err.response?.data?.message || err.message));
    } finally {
      setDeleteDialogOpen(false);
      setUserToDelete(null);
    }
  };
  const handleCancelDelete = () => {
    setDeleteDialogOpen(false);
    setUserToDelete(null);
  };

  const handleOpenChangePassword = (user) => {
    setSelectedUser(user);
    setPasswordForm({ newPassword: '', confirmPassword: '' });
    setChangePasswordDialog(true);
  };

  const handleCloseChangePassword = () => {
    setChangePasswordDialog(false);
    setSelectedUser(null);
    setPasswordForm({ newPassword: '', confirmPassword: '' });
  };

  const handlePasswordChange = (e) => {
    setPasswordForm({
      ...passwordForm,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmitPassword = async () => {
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      alert('Passwords do not match');
      return;
    }

    try {
      setLoading(true);
      await api.put(`/users/${selectedUser.id}/password`, {
        TA_User_Password: passwordForm.newPassword
      });
      showSnackbar('Password changed successfully', 'success');
      handleCloseChangePassword();
    } catch (err) {
      alert('Failed to change password: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredUsers = users.filter((user, idx) => {
    const searchText = search.toLowerCase();
    return (
      (String(idx + 1).includes(searchText)) ||
      user.name?.toLowerCase().includes(searchText) ||
      user.email?.toLowerCase().includes(searchText) ||
      (user.username || '').toLowerCase().includes(searchText) ||
      (user.mobile || '').toLowerCase().includes(searchText) ||
      (user.roleName || user.role || '').toLowerCase().includes(searchText) ||
      (user.status || '').toLowerCase().includes(searchText)
    );
  });

  const pagedUsers = filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleViewUser = (user) => {
    setViewedUser(user);
    setViewUserDialog(true);
  };
  const handleCloseViewUser = () => {
    setViewedUser(null);
    setViewUserDialog(false);
  };

  if(loading){
    if(isSmallScreen){
      return(
        <>
          <Box
            sx={{
            p: { xs: 2, sm: 3 },
            mb: 2,
            borderRadius: 3,
            background: theme.palette.mode == 'dark' ? '#32373a' :  'white',
            boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
            display: 'flex',
            flexDirection: { xs: 'row', md: 'row' },
            alignItems: 'center',
            gap: 2,
            justifyContent: 'space-between',
            position: 'sticky',
            top: isSmallScreen?10:0,
            zIndex: 1000,}}
          >

            <Typography variant="h5" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text',  }}>
              User Master
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2,flexDirection: { xs: 'row', sm: 'row' } }}>
              <IconButton
                onClick={handleSearchClick}
                color='primary'
                // sx={{
                //   bgcolor: theme.palette.primary.main,
                //   color: theme.palette.primary.contrastText,
                //   borderRadius: 2, boxShadow: 1,
                //   '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 2, },
                //   height: 40, width: 40,
                // }}
              >
                <SearchIcon />
              </IconButton>
              <IconButton
                onClick={handleOpen}
                color='primary'
                // sx={{
                //   bgcolor: theme.palette.primary.main,
                //   color: theme.palette.primary.contrastText,
                //   borderRadius: 2, boxShadow: 1, height: 40, width: 40,
                //   '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 2,}, 
                // }}
              >
                <AddIcon />
              </IconButton>

              <Popover open={openPopover} anchorEl={anchorEl} onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
                transformOrigin={{  vertical: 'top',  horizontal: 'left', }}
                PaperProps={{ sx: { p: 1, boxShadow: 'none', backgroundColor: 'rgba(255, 255, 255, 0.2)', borderRadius: 2, width: '60vw',  maxWidth: 400, }, }}
              >
                <SearchInput value={search} onChange={(e) => setSearch(e.target.value)}  autoFocus />  
              </Popover> 
            </Box>
          </Box>
          <Grid container spacing={1}>
            {Array.from(new Array(5)).map((_, idx) => (
              <Grid item xs={12} sm={12} key={idx}>
                <Card
                  elevation={3}
                  sx={{
                    borderRadius: 3,
                    background: '#fff',
                    m: 1,
                    mt: 0,
                  }}
                >
                  <CardContent>
                    <Box display="flex" alignItems="flex-start" justifyContent="space-between" gap={2}>
                      <Box>
                        <Skeleton variant="text" width={40} height={24} /> {/* For # index */}
                        <Skeleton variant="text" width={150} height={28} sx={{ mt: 0.5 }} /> {/* Name */}
                        <Skeleton variant="text" width={120} height={20} sx={{ mt: 0.5 }} /> {/* Username */}
                        <Skeleton variant="text" width={120} height={20} sx={{ mt: 0.5 }} /> {/* Mobile */}
                        <Skeleton variant="text" width={100} height={20} sx={{ mt: 0.5 }} /> {/* Role */}
                      </Box>
                      {/* <Box display="flex" flexDirection="column" gap={1}>
                        <Skeleton variant="circular" width={40} height={40} /> 
                      </Box> */}
                    </Box>
                  </CardContent>

                  <CardActions sx={{ justifyContent: 'space-between', px: 2, pb: 2 }}>
                    <Box display="flex" gap={1}>
                      <Skeleton variant="rectangular" width={60} height={32} />
                      <Skeleton variant="rectangular" width={60} height={32} />
                    </Box>
                    <Box display="flex" gap={1}>
                      <Skeleton variant="rectangular" width={90} height={32} />
                      <Skeleton variant="rectangular" width={70} height={32} />
                    </Box>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
      </>
      );
    }
    return(
      <>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between", 
            background: theme.palette.mode == 'dark' ? '#32373a' :  'white',
            boxShadow:'0 2px 12px rgba(0,0,0,0.06)',
            mb: 3,
            gap: 2,
            flexWrap: "wrap", 
            p: { xs: 1, sm: 3 },
            borderRadius:'12px',
          }}
        >
        
          <Typography variant="h4" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color:theme.palette.mode === 'dark' ? 'white' : 'black', mb: { xs: 2, md: 0 } }}>
            User Master
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap",  }} >

            <SearchInput value={search} onChange={(e) => setSearch(e.target.value)} />

            <Button
              variant="contained"
              onClick={handleOpen}
              startIcon={<AddIcon />}
              sx={{
                bgcolor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                fontWeight: 700,
                borderRadius: 3,
                boxShadow: 2,
                fontSize: { xs: "0.775rem", sm: "1rem" },
                px: 3,
                height: 44,
                textTransform: "none",
                "&:hover": {
                  bgcolor: theme.palette.primary.dark,
                  boxShadow: 4,
                },
              }}
            >
              Add User
            </Button>
          </Box>
        </Box>

        <Paper
          elevation={1}
          sx={{
            borderRadius: 3,
            boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
            p: 0,
            overflow: 'auto',
            mb: 3,
          }}
        >
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: 'primary.main' }}>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', color: 'white' }}>
                    SL No.
                  </TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', color: 'white', textAlign: 'left' }}>
                    Name
                  </TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', color: 'white', textAlign: 'left' }}>
                    Role
                  </TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', color: 'white', textAlign: 'left' }}>
                    Mobile
                  </TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem', color: 'white', textAlign: 'center' }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {Array.from(new Array(10)).map((_, idx) => (
                  <TableRow key={idx}>
                    <TableCell>
                      <Skeleton variant="text" width={20} height={24} />
                    </TableCell>
                    <TableCell>
                      <Skeleton variant="text" width={120} height={24} />
                    </TableCell>
                    <TableCell>
                      <Skeleton variant="text" width={100} height={24} />
                    </TableCell>
                    <TableCell>
                      <Skeleton variant="text" width={100} height={24} />
                    </TableCell>
                    <TableCell>
                      <Box display="flex" justifyContent="space-evenly">
                        <Skeleton variant="circular" width={36} height={36} />
                        <Skeleton variant="circular" width={36} height={36} />
                        <Skeleton variant="circular" width={36} height={36} />
                        <Skeleton variant="circular" width={36} height={36} />
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Skeleton for pagination */}
          <Box sx={{ px: 2, py: 1, backgroundColor: '#fff' }}>
            <Skeleton variant="rectangular" width="100%" height={40} />
          </Box>
        </Paper>
      </>
    )
  }

  return (
    <Box>
      {isSmallScreen ? (
        <Box
          sx={{
          p: { xs: 2, sm: 3 },
          mb: 2,
          borderRadius: 3,
          background: theme.palette.mode == 'dark' ? '#32373a' :  'white',
          boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
          display: 'flex',
          flexDirection: { xs: 'row', md: 'row' },
          alignItems: 'center',
          gap: 2,
          justifyContent: 'space-between',
          position: 'sticky',
          top: isSmallScreen?10:0,
          zIndex: 1000,}}
        >

          <Typography variant="h5" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text',  }}>
            User Master
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2,flexDirection: { xs: 'row', sm: 'row' } }}>
            <IconButton
              onClick={handleSearchClick}
              color='primary'
              // sx={{
              //   bgcolor: theme.palette.primary.main,
              //   color: theme.palette.primary.contrastText,
              //   borderRadius: 2, boxShadow: 1,
              //   '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 2, },
              //   height: 40, width: 40,
              // }}
            >
              <SearchIcon />
            </IconButton>
            <IconButton
              onClick={handleOpen}
              color='primary'
              // sx={{
              //   bgcolor: theme.palette.primary.main,
              //   color: theme.palette.primary.contrastText,
              //   borderRadius: 2, boxShadow: 1, height: 40, width: 40,
              //   '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 2,}, 
              // }}
            >
              <AddIcon />
            </IconButton>

            <Popover open={openPopover} anchorEl={anchorEl} onClose={handleClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
              transformOrigin={{  vertical: 'top',  horizontal: 'left', }}
              PaperProps={{ sx: { p: 1, boxShadow: 'none', backgroundColor: 'rgba(255, 255, 255, 0.2)', borderRadius: 2, width: '60vw',  maxWidth: 400, }, }}
            >
              <SearchInput value={search} onChange={(e) => setSearch(e.target.value)}  autoFocus />  
            </Popover> 
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between", 
            background: theme.palette.mode == 'dark' ? '#32373a' :  'white',
            boxShadow:'0 2px 12px rgba(0,0,0,0.06)',
            mb: 3,
            gap: 2,
            flexWrap: "wrap", 
            p: { xs: 1, sm: 3 },
            borderRadius:'12px',
          }}
        >
        
          <Typography variant="h4" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color:theme.palette.mode === 'dark' ? 'white' : 'black', mb: { xs: 2, md: 0 } }}>
            User Master
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap",  }} >

            <SearchInput value={search} onChange={(e) => setSearch(e.target.value)} />

            <Button
              variant="contained"
              onClick={handleOpen}
              startIcon={<AddIcon />}
              sx={{
                bgcolor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                fontWeight: 700,
                borderRadius: 3,
                boxShadow: 2,
                fontSize: { xs: "0.775rem", sm: "1rem" },
                px: 3,
                height: 44,
                textTransform: "none",
                "&:hover": {
                  bgcolor: theme.palette.primary.dark,
                  boxShadow: 4,
                },
              }}
            >
              Add User
            </Button>
          </Box>
      </Box>
      )}

      {/* Responsive: Cards on small screens, Table on larger screens */}
      {isSmallScreen ? (
        <Grid container spacing={1}>
          {pagedUsers.map((user, idx) => (
            <Grid item xs={12} sm={12} key={user.id}>
              <Card
                elevation={3}
                sx={{
                  borderRadius: 3,
                  background: theme.palette.background.paper,
                  // border:'1px solid red',
                  m:1,
                  mt:0
                }}
              >
                <CardContent>
                  <Box display="flex" alignItems="flex-start" justifyContent="space-between" gap={2}>
                    <Box>
                      <Typography variant="subtitle2" color="#b0b0b0">
                        #{page * rowsPerPage + idx + 1}
                      </Typography>
                      <Typography variant="h6" sx={{ textTransform: 'capitalize',fontWeight:600,color:'background.text',fontSize:17 }}>
                        {user.name}
                      </Typography>
                      {/* {user.email && (
                        <Typography variant="body2" color="text.secondary">
                          <span style={{ fontWeight: 700,fontSize:17 }}> Email : </span>{user.email}
                        </Typography>
                      )} */}
                      {user.username && (
                        <Typography variant="body2" color="background.text">
                          <span style={{ fontWeight: 600,fontSize:12 }}> Username : </span>{user.username}
                        </Typography>
                      )}
                      {user.mobile && (
                        <Typography variant="body2" color="background.text">
                          <span style={{ fontWeight: 600,fontSize:12 }}> Mobile : </span>{user.mobile}
                        </Typography>
                      )}
                      {(user.roleName || user.role) && (
                        <Typography variant="body2" color="background.text">
                          <span style={{ fontWeight: 600,fontSize:12 }}> Role : </span>{user.roleName || user.role}
                        </Typography>
                      )}
                      {/* {user.status && (
                        <Typography variant="body2" color="text.secondary">
                          <span style={{ fontWeight: 700,fontSize:17 }}> Status : </span>{user.status}
                        </Typography>
                      )} */}
                    </Box>

                    {/* Overflow menu for actions */}
                    {/* <Box>
                      <IconButton onClick={(e) => handleMenuOpen(e, user.id)} aria-label="more actions">
                        <MoreVertIcon />
                      </IconButton>
                      <Menu
                        anchorEl={menuAnchor}
                        open={menuUserId === user.id}
                        onClose={handleMenuClose}
                      >
                        <MenuItem onClick={() => { handleViewUser(user); handleMenuClose(); }}>View</MenuItem>
                        <MenuItem onClick={() => { handleEdit(user); handleMenuClose(); }}>Edit</MenuItem>
                        <MenuItem onClick={() => { handleOpenChangePassword(user); handleMenuClose(); }}>Change Password</MenuItem>
                        <MenuItem onClick={() => { handleDelete(user.id); handleMenuClose(); }}>Delete</MenuItem>
                      </Menu>
                    </Box> */}
                  </Box>
                </CardContent>

                <CardActions sx={{ px: 2, pb: 2, display: 'flex', justifyContent:'space-between', flexDirection: { xs: 'row', sm: 'row' }, gap: 1, }} >
                  <Tooltip title="View">
                    <IconButton color="primary" onClick={() => handleViewUser(user)}>
                      <Visibility />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Edit">
                    <IconButton color="primary" onClick={() => handleEdit(user)}>
                      <EditIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Change Password">
                    <IconButton color="warning" onClick={() => handleOpenChangePassword(user)}>
                      <LockResetIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Delete">
                    <IconButton color="error" onClick={() => handleDelete(user.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
              </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
      <Paper elevation={1} sx={{ borderRadius: 3, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', p: 0, overflow: 'auto', background: 'background.paper', mb: 3, }}>          
          <TableContainer  sx={{ maxHeight: 540 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow sx={{ bgcolor: 'primary.main' }}>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem',  background: '#0088cc', color: '#fff' }}>SL No.</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem',  background: '#0088cc', color: '#fff' ,textAlign:"left" }}>Name</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem',  background: '#0088cc', color: '#fff' ,textAlign:"left" }}>Role</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem',  background: '#0088cc', color: '#fff' ,textAlign:"left" }}>Mobile</TableCell>
                  <TableCell sx={{ fontWeight: 700, fontSize: '1rem',  background: '#0088cc', color: '#fff' ,textAlign:"center" }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pagedUsers.map((user, idx) => (
                  <TableRow
                    key={user.id}
                    sx={{ transition: 'background 0.2s', cursor: 'pointer', '&:hover': { backgroundColor: theme.palette.action.hover } }}
                  >
                    <TableCell sx={{ color: theme.palette.getContrastText(theme.palette.background.paper) }}>{page * rowsPerPage + idx + 1}</TableCell>
                    <TableCell sx={{ color: theme.palette.getContrastText(theme.palette.background.paper), textTransform: 'capitalize' }}>{user.name}</TableCell>
                    <TableCell sx={{ color: theme.palette.getContrastText(theme.palette.background.paper), textTransform: 'capitalize' }}>{user.roleName || user.role}</TableCell>
                    <TableCell sx={{ color: theme.palette.getContrastText(theme.palette.background.paper) }}>{user.mobile}</TableCell>
                    <TableCell sx={{ color: theme.palette.getContrastText(theme.palette.background.paper) }}>
                      <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-evenly' }}>
                        <IconButton
                          color="info"
                          onClick={() => handleViewUser(user)}
                          sx={{
                            '&:hover': { bgcolor: '#eaf6ff' },
                            borderRadius: 2,
                          }}
                          aria-label="view user"
                        >
                          <Visibility />
                        </IconButton>
                        
                        <EditButton onClick={() => handleEdit(user)} />
                        <DeleteButton onClick={() => handleDelete(user.id)} />

                        <IconButton
                          // size="large"
                          color="warning"
                          onClick={() => handleOpenChangePassword(user)}
                          sx={{
                            '&:hover': { bgcolor: 'rgba(255, 160, 0, 0.18)' },
                            borderRadius: 2,
                          }}
                        >
                          <LockResetIcon />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ px: 2, py: 1, backgroundColor:theme.palette.mode === 'dark' ? 'transparent' : '#fff', }}>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={filteredUsers.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                  // marginBottom: 0,
                },
                backgroundColor:theme.palette.mode === 'dark' ? 'transparent' : '#fff',
                color:theme.palette.mode === 'dark' ? 'white' : 'black',
              }}
            />
          </Box>
      </Paper>
      )}

      

      {/* Add/Edit User Dialog */}
      <Dialog 
        open={open} 
        onClose={handleClose}
        fullScreen={isSmallScreen}
        maxWidth="md"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            margin: { xs: 0, sm: 2 },
            width: { xs: '90%', md: '80%' },
            maxWidth: { xs: '100%', sm: 600, md: 800 },
            height: { xs: '90dvh', sm: 'auto' },
            maxHeight: { xs: 'fit-content', sm: 'fit-content' }
          }
        }}
      >
        <DialogTitle 
          sx={{ 
            color: 'background.text',
            fontSize: { xs: '1.25rem', sm: '1.5rem' },
            fontWeight: '600', 
            pb: 0,
            pt: { xs: 2, sm: 3 }
          }}
        >
          {editUserId !== null ? 'Edit User' : 'Add User'}
        </DialogTitle>
        
        <DialogContent 
          sx={{ 
            pt: { xs: 1, sm: 2 },
            pb: { xs: 1, sm: 2 }
          }}
        >
          {/* Name & Email - Stack on mobile, row on desktop */}
          <Box 
            sx={{ 
              display: 'flex', 
              flexDirection: { xs: 'row', sm: 'row' }, 
              gap: { xs: 1.5, sm: 2 },
              mb: 1
            }}
          >
            <TextField 
              label="Name" 
              name="name" 
              value={form.name || ""} 
              onChange={handleChange} 
              fullWidth 
              margin="normal" 
              size={isSmallScreen ? "small" : "medium"}
              InputLabelProps={{ style: { color: theme.palette.background.text } }} 
              InputProps={{ style: { color: theme.palette.background.text } }} 
            />
            <TextField 
              label="Email" 
              name="email" 
              value={form.email || ""} 
              onChange={handleChange} 
              fullWidth 
              margin="normal" 
              size={isSmallScreen ? "small" : "medium"}
              InputLabelProps={{ style: { color: theme.palette.background.text } }} 
              InputProps={{ style: { color: theme.palette.background.text } }} 
            />
          </Box>     

          {/* Role & Mobile - Stack on mobile, row on desktop */}
          <Box 
            sx={{ 
              display: 'flex', 
              flexDirection: { xs: 'row', sm: 'row' }, 
              gap: { xs: 1.5, sm: 2 },
              mb: 1
            }}
          >
            <TextField 
              select 
              label="Role" 
              name="role" 
              value={form.role || ""} 
              onChange={handleChange} 
              fullWidth 
              margin="normal" 
              size={isSmallScreen ? "small" : "medium"}
              InputLabelProps={{ style: { color: theme.palette.background.text } }} 
              InputProps={{ style: { color: theme.palette.background.text } }}
            >
              {roles.map((role) => (
                <MenuItem key={role._id} value={role._id} sx={{ color: 'background.text' }}>
                  {role.TA_Role_Name}
                </MenuItem>
              ))}
            </TextField>
            <TextField 
              label="Mobile" 
              name="mobile" 
              value={form.mobile || ""} 
              onChange={handleChange} 
              fullWidth 
              margin="normal" 
              size={isSmallScreen ? "small" : "medium"}
              error={!!phoneError} 
              helperText={phoneError} 
              InputLabelProps={{ style: { color: theme.palette.background.text } }} 
              InputProps={{ style: { color: theme.palette.background.text } }} 
            />
          </Box>

          {/* Master User & Master PRO - Stack on mobile, row on desktop */}
          <Box 
            sx={{ 
              display: 'flex', 
              flexDirection: { xs: 'row', sm: 'row' }, 
              gap: { xs: 1.5, sm: 2 },
              mb: 1
            }}
          >
            <TextField 
              select 
              label="Master User" 
              name="masterRef" 
              value={form.masterRef || ""} 
              onChange={handleChange} 
              error={!!masterUserError} 
              fullWidth 
              margin="normal" 
              size={isSmallScreen ? "small" : "medium"}
              InputLabelProps={{ style: { color: theme.palette.background.text } }} 
              helperText={masterUserError} 
              InputProps={{ style: { color: theme.palette.background.text } }}
            >
              {masterUsers.map((user) => (
                <MenuItem key={user._id} value={user._id} sx={{ color: 'background.text' }}>
                  {user.name || user.email || 'Unnamed User'}
                </MenuItem>
              ))}
            </TextField>
            <TextField 
              select 
              label="Master PRO" 
              sx={{display:canHidePro?'none':'flex'}}
              name="proRef" 
              value={form.proRef || ""} 
              onChange={handleChange} 
              fullWidth 
              margin="normal" 
              size={isSmallScreen ? "small" : "medium"}
              error={!!masterProError} 
              InputLabelProps={{ style: { color: theme.palette.background.text } }} 
              helperText={masterProError} 
              InputProps={{ style: { color: theme.palette.background.text } }}
            >
              {masterPro.map((pro) => (
                <MenuItem key={pro._id} value={pro._id} sx={{ color: 'background.text' }}>
                  {pro.name || pro.email || 'Unnamed User'}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          {/* Address Section - Always stacked */}
          {/* <Box sx={{display:'flex',flexDirection:{xs:'row',md:'row'}, gap:{xs:1.5,md:2}}} >
            <TextField 
              label="Address Line 1"  
              fullWidth 
              margin="normal" 
              value={form.addressOne}
              onChange={(e)=>setForm({...form,addressOne:e.target.value})}
              size={isSmallScreen ? "small" : "medium"}
              InputLabelProps={{ style: { color: theme.palette.background.text } }} 
              InputProps={{ style: { color: theme.palette.background.text } }}
            />
            <TextField 
              label="Address Line 2"  
              fullWidth 
              margin="normal" 
              value={form.addressTwo}
              onChange={(e)=>setForm({...form,addressTwo:e.target.value})}
              size={isSmallScreen ? "small" : "medium"}
              InputLabelProps={{ style: { color: theme.palette.background.text } }} 
              InputProps={{ style: { color: theme.palette.background.text } }}
            />
          </Box>
          <Box sx={{padding:{xs:0,md:'0 10px 0 0'},width:{xs:'100%',md:'50%'}}} >
            <TextField 
              label="Land Mark"  
              fullWidth 
              margin="normal" 
              value={form.Landmark}
              onChange={(e)=>setForm({...form,Landmark:e.target.value})}
              size={isSmallScreen ? "small" : "medium"}
              InputLabelProps={{ style: { color: theme.palette.background.text } }} 
              InputProps={{ style: { color: theme.palette.background.text } }}
            />
          </Box> */}

          {/* Login Credentials */}
          <Typography 
            sx={{ 
              mt: 1, 
              fontWeight: '600',
              fontSize: { xs: '0.9rem', sm: '1rem' },
              color:'background.textsecondary'
            }}
          >
            Login Credentials
          </Typography>
          
          <TextField 
            label="User Name" 
            name="username" 
            value={form.username || ""} 
            onChange={handleChange} 
            fullWidth 
            margin="normal" 
            size={isSmallScreen ? "small" : "medium"}
            InputLabelProps={{ style: { color: theme.palette.background.text } }} 
            InputProps={{ style: { color: theme.palette.background.text } }} 
          />
          
          {editUserId === null && (
            <Box sx={{display:'flex',flexDirection:{xs:'column',md:'row'}, gap:{xs:0,md:2}}} >
              <TextField
                label="Password"
                name="password"
                type={showPassword ? "text" : "password"}
                value={form.password || ""}
                onChange={handleChange}
                fullWidth
                margin="normal"
                size={isSmallScreen ? "small" : "medium"}
                InputLabelProps={{ style: { color: theme.palette.background.text } }}
                error={!!passwordError}
                helperText={passwordError && form.password ? passwordError : ''}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton 
                        aria-label="toggle password visibility" 
                        onClick={() => setShowPassword((show) => !show)} 
                        edge="end"
                        size={isSmallScreen ? "small" : "medium"}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                  style: { color: theme.palette.background.text },
                }}
              />
              <TextField
                label="Confirm Password"
                name="confirmPassword"
                type={showConfirmPassword ? "text" : "password"}
                value={form.confirmPassword || ""}
                onChange={handleChange}
                fullWidth
                margin="normal"
                size={isSmallScreen ? "small" : "medium"}
                error={!!passwordError}
                helperText={passwordError && form.confirmPassword ? passwordError : ''}
                InputLabelProps={{ style: { color: theme.palette.background.text } }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton 
                        aria-label="toggle confirm password visibility" 
                        onClick={() => setShowConfirmPassword((show) => !show)} 
                        edge="end"
                        size={isSmallScreen ? "small" : "medium"}
                      >
                        {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                  style: { color: theme.palette.background.text },
                }}
              />
            </Box>
          )}

          {/* Checkbox Section */}
          {/* <FormControlLabel
            sx={{ mt: 1 }}
            control={
              <Checkbox 
                sx={{ mr: { xs: 1, sm: 2 } }}
                checked={notifyAlertType.isActive}
                onChange={(e) => setNotifyAlertType({type:'Call',isActive:e.target.checked})}
                color="primary"
                size={isSmallScreen ? "small" : "medium"}
              />
            }
            label={
              <Typography sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                Do you agree Notification Alert is Call Yes/No ?
              </Typography>
            }
          /> */}
        </DialogContent>
        
        <DialogActions 
          sx={{ 
            p: { xs: 2, sm: 3 },
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 1, sm: 0 }
          }}
        >
          <Button 
            onClick={handleClose} 
            variant="outlined"
            fullWidth={isSmallScreen}
            size={isSmallScreen ? "medium" : "large"}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleSubmit} 
            variant="contained" 
            disabled={loading}
            fullWidth={isSmallScreen}
            size={isSmallScreen ? "medium" : "large"}
          >
            {editUserId !== null ? 'Update' : (loading ? 'Adding...' : 'Add')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteDialogOpen} onClose={handleCancelDelete}>
        <DialogTitle sx={{color:'background.text'}}>Confirm Delete</DialogTitle>
        <DialogContent sx={{color:'background.text'}}>
          {userToDelete !== null && (
            <>Are you sure you want to delete <b>{users.find(u => u.id === userToDelete)?.name || 'this user'}</b>?</>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete}>Cancel</Button>
          <Button onClick={handleConfirmDelete} color="error" variant="contained">Delete</Button>
        </DialogActions>
      </Dialog>

      {/* Change Password Dialog */}
      <Dialog open={changePasswordDialog} onClose={handleCloseChangePassword}>
        <DialogTitle sx={{ color: 'background.text' }}>Change Password for {selectedUser?.name}</DialogTitle>
        <DialogContent>
          <TextField
            margin="normal"
            fullWidth
            name="newPassword"
            label="New Password"
            type={showPassword ? "text" : "password"}
            value={passwordForm.newPassword}
            onChange={handlePasswordChange}
            InputLabelProps={{ style: { color: theme.palette.background.text } }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton aria-label="toggle password visibility" onClick={() => setShowPassword(!showPassword)} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
              style: { color: theme.palette.background.text },
            }}
          />
          <TextField
            margin="normal"
            fullWidth
            name="confirmPassword"
            label="Confirm New Password"
            type={showConfirmPassword ? "text" : "password"}
            value={passwordForm.confirmPassword}
            onChange={handlePasswordChange}
            error={passwordForm.newPassword !== passwordForm.confirmPassword && passwordForm.confirmPassword !== ''}
            helperText={passwordForm.newPassword !== passwordForm.confirmPassword && passwordForm.confirmPassword !== '' ? 'Passwords do not match' : ''}
            InputLabelProps={{ style: { color: theme.palette.background.text } }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton aria-label="toggle password visibility" onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
              style: { color: theme.palette.background.text },
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseChangePassword}>Cancel</Button>
          <Button
            onClick={handleSubmitPassword}
            color="primary"
            variant="contained"
            disabled={!passwordForm.newPassword || !passwordForm.confirmPassword || passwordForm.newPassword !== passwordForm.confirmPassword || loading}
          >
            {loading ? 'Updating...' : 'Update Password'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      {/* <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
        sx={{
          '& .MuiSnackbarContent-root': {
            backgroundColor: snackbar.severity === 'error' ? '#d32f2f' : '#43a047',
          }
        }}
      /> */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* View User Details Dialog */}
      <Dialog open={viewUserDialog} onClose={handleCloseViewUser} maxWidth="xs" fullWidth>
        <DialogTitle sx={{color:'background.text'}}>User Details</DialogTitle>
        <DialogContent dividers>
          {viewedUser && (
            <Box display="flex" flexDirection="column" gap={2}>
              <Typography sx={{color:'background.text'}}><b>Name:</b> {viewedUser.name}</Typography>
              <Typography sx={{color:'background.text'}}><b>Email:</b> {viewedUser.email}</Typography>
              <Typography sx={{color:'background.text'}}><b>User Name:</b> {viewedUser.username}</Typography>
              <Typography sx={{color:'background.text'}}><b>Mobile:</b> {viewedUser.mobile}</Typography>
              {viewedUser.roleName && <Typography sx={{color:'background.text'}}><b>Role:</b> {viewedUser.roleName}</Typography>}
              {viewedUser.status && <Typography sx={{color:'background.text'}}><b>Status:</b> <PillComponent status={viewedUser.status} /></Typography>}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseViewUser} color="primary" variant="contained">Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default UserMasterPage;
